import styles from './GuestEvent.module.scss'

import { GuestNameFeild } from './components/guest-name-feild';
import { FormPostMedia } from './components/form-post-media';
import { PostSuccess } from './components/post-success';
import { PhotoHero } from '../../elements/photo-hero';
import { UserImage } from '../../elements/user-image';
import { AppLayout } from '../../elements/app-layout';
import useGuestEvent from './useGuestEvent';
import { Loading } from '../../elements/Loading';
import { FormProvider } from 'react-hook-form';
export function GuestEvent() {

    const {justPosted, event, ...controller} = useGuestEvent()
    if(justPosted.isOpen) return <PostSuccess hideSuccessPage={justPosted.toogle} event={event}/>
    
    return (
        <AppLayout>
            {!!event ? <>
                <PhotoHero coverUrl={event.thumbnail_url}>
                    <h2 className={styles.title}>
                        {event?.title}
                    </h2>

                    <div className={styles.authorContainer}>
                        <UserImage first_name={event?.host?.first_name} last_name={event?.host?.last_name} />
                        <label>{event?.host?.name}</label>
                    </div>
                </PhotoHero>

                <div className={styles.content}>
                    <label className={styles.note}>
                        Make {event?.host?.first_name}’s event unforgettable! Add a post.
                    </label>
                    <FormProvider {...controller.formController}>
                            <GuestNameFeild hasName={controller.hasName}/>

                            <FormPostMedia savingPost={controller.savingPost} onSubmit={controller.formController.handleSubmit(controller.onSubmit)}/>
                        
                    </FormProvider>
                </div>
            </> :
            event === null ? <div className={styles.doesNotExist}>
                Event does not exist
            </div> : <div className={styles.loading}>
                <Loading size={100}/>
            </div>
            }
        </AppLayout>
    )
}
